/**
 * useDocumentation.ts
 * Feature: 041-documentation-backend
 * Author: Peter Dobler
 * Date: 2026-05-15
 * Constitution Version: 1.12.0
 *
 * Purpose: React Query hooks for documentation categories and operational runbooks.
 */

import { useQuery } from '@tanstack/react-query';
import { getDocCategories, getRunbooks } from '../services/documentationService';
import type { DocCategory } from '../pages/Help/DocumentationPage';
import type { Runbook } from '../pages/Help/RunbooksPage';

export const documentationKeys = {
  all: ['documentation'] as const,
  categories: () => [...documentationKeys.all, 'categories'] as const,
  runbooks: () => [...documentationKeys.all, 'runbooks'] as const,
};

export function useDocCategories() {
  return useQuery<DocCategory[], Error>({
    queryKey: documentationKeys.categories(),
    queryFn: getDocCategories,
    staleTime: 5 * 60_000, // 5 minutes — static content, rarely changes
  });
}

export function useRunbooks() {
  return useQuery<Runbook[], Error>({
    queryKey: documentationKeys.runbooks(),
    queryFn: () => getRunbooks(),
    staleTime: 5 * 60_000,
  });
}
